"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLayouts6 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var bricks_1 = require("../../bricks");
var TextLayouts6 = function (_a) {
    var bgImage = _a.bgImage, items = _a.items;
    // Custom column padding
    // https://getbootstrap.com/docs/5.3/layout/gutters/#horizontal-gutters
    // x5 = 5px based horizontal spacing, see $spacersX in _variables.scss
    var px = 5;
    return ((0, jsx_runtime_1.jsxs)("section", __assign({ className: "section-padding-lg text-white position-realtive overflow-hidden overlay overlay-scrim-x fw-light" }, { children: [(0, jsx_runtime_1.jsx)(bricks_1.BackgroundImage, { src: bgImage }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "container x5-px-md-".concat(px) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row x5-mx-md-n".concat(px) }, { children: items.map(function (item, index) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-md-6 col-lg-4 x5-px-md-".concat(px) }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "h6 small-sm ls-1-5 mb-5" }, { children: item.heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "opacity-100 lead lh-1-75 mb-7 mb-lg-5" }, { children: item.paragraph }))] }), index)); }) })) }))] })));
};
exports.TextLayouts6 = TextLayouts6;
